import { Badge, IconButton, Tab, Tabs, WithStyles } from '@material-ui/core';
import { createStyles, Theme, withStyles } from '@material-ui/core/styles';
import {
  FullscreenExit,
  FullscreenSharp,
  Refresh,
  ZoomIn,
  ZoomOut
} from '@material-ui/icons';
import { createLogStream, Logger } from 'aws-cloudwatch-log-browser';
import { cloneDeep } from 'lodash';
import moment from 'moment';
import PubNubReact from 'pubnub-react';
import React from 'react';
import Fullscreen from 'react-full-screen';
import { connect } from 'react-redux';
import axios from '../../axios-pod';
import Snooze from '../../components/Snooze/Snooze';
import IconDisplay from '../../components/UI/IconDisplay/IconDisplay';
import MainHeading from '../../components/UI/MainHeading/MainHeading';
import MainSection from '../../components/UI/MainSection/MainSection';
import MyTooltip from '../../components/UI/MyTooltip/MyTooltip';
import SubHeading from '../../components/UI/SubHeading/SubHeading';
import SubSection from '../../components/UI/SubSection/SubSection';
import ConfirmationDialog from './../../components/UI/ConfirmationDialog/ConfirmationDialog';

import {
  IConfirmationDialogState,
  IFeedState,
  IPlayoutScreen,
  IScreenState,
  IState,
  IUser,
  IWebRTCConfig
} from '../../models/states';
import {
  fetchPlayoutUrls,
  updatePlayoutFeeds
} from '../../store/actions/playoutActions';
import {
  ConfirmationTypes,
  initialConfirmationState,
  UserRoles
} from '../../utilities/utilities';
import withErrorHandler from '../../utilities/withErrorHandler';
import sadsmiley from './../../static/icons/sadsmiley.svg';
import smilie from './../../static/icons/smilie.svg';
import FarFieldMonitoring from './FarFieldMonitoring';

// import alertTone from "./../../static/icons/audio/alertTone.wav"
import Switch from '@material-ui/core/Switch';
import MyDialog from '../../components/UI/MyDialog/MyDialog';
import './Fullscreen.css';
import MessageLogs from './MessageLogs';
import PlayoutStreamSummary from './PlayoutStreamSummary';

const logAxios = require('axios');
const aws4 = require('aws-cloudwatch-log-browser/aws4-browser/aws4-crypto-js');
const alertTone = require('./../../static/audio/ring.wav') as string;
const styles = (theme: Theme) =>
  createStyles({
    mainStyles: {
      display: 'flex',
      justifyContent: 'space-between'
    },
    containerDiv: {
      display: 'flex',
      alignItems: 'center',
      width: '100%',
      position: 'relative'
    },
    heading: {
      marginRight: '0.5rem'
    },
    fulscrnSwitch: {
      position: 'absolute',
      right: 0,
      color: 'white'
    },
    switchBase: {
      '&$checked': {
        color: '#f8e200'
      }
    },
    margin: {
      marginRight: '2rem',
      width: '25rem'
    },
    subheadingBar: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      width: '100%',
      marginTop: '-1rem'
    },
    iconButton: {
      width: '3rem',
      height: '3rem'
    }
  });

class PlayoutPod extends React.Component<IPlayoutProps, IPlayoutOwnState> {
  pubnub;
  interval;
  constructor(props: IPlayoutProps) {
    super(props);
    this.state = {
      width: 22.5,
      // width: 25,
      isFull: false,
      searchText: '',
      tab: 0,
      refresh: 0,
      isSubscribed: false,
      openPlayoutSummary: false,
      selectedPlayoutFeed: undefined,
      audioNotify: localStorage.getItem('disableNotification') !== 'true',
      alarmFeeds: [],
      isAlarming: false,
      cloudWatchLock: false,
      alarm: new Audio(alertTone),
      isRefresh: true,
      messages: [],
      confirmationDialogProps: initialConfirmationState,
      snoozeHrs: 0,
      snoozeMins: 0
    };
    this.pubnub = new PubNubReact({
      subscribeKey: process.env.REACT_APP_PUBNUB_SUBSCRIBE_KEY
    });
    this.pubnub.init(this);
  }
  // componentWillMount() {

  // }
  componentWillUnmount() {
    const channels = this.props.playoutIds.map(
      (id: string) => `doordarshan|${id.split('#').join('|')}`
    );
    this.pubnub.unsubscribe({
      channels
    });

    this.playAlarm(true);
    clearInterval(this.interval);
  }

  componentDidMount() {
    const { screenMap, selectedScreen } = this.props.screens;
    const { customers } = screenMap[selectedScreen];
    const customerNameList = customers.map(customer => {
      return customer.name;
    });
    const feedCodes = customers.flatMap(customer => customer.channels);
    fetchPlayoutUrls(feedCodes, customerNameList);
    this.resetSnooze();
    this.interval = setInterval(
      () => this.setState({ refresh: Date.now() }),
      60 * 10 * 1000
    );
  }

  goFull = (event: React.ChangeEvent<HTMLInputElement>) => {
    this.setState({ isFull: event.target.checked });
  };
  handleSearch = (event: React.ChangeEvent<HTMLInputElement>) => {
    this.setState({ searchText: event.target.value.toLowerCase() });
  };
  handleTabChange = (e, tab) => {
    this.setState({ tab });
  };

  resetSnooze() {
    setInterval(() => {
      const currentTime = moment();
      this.state.messages.forEach(msg => {
        if (msg.snooze) {
          const snoozeUntil = moment(msg.snooze_until);
          if (currentTime.isAfter(snoozeUntil)) {
            msg.snooze = false;
            msg.snooze_until = undefined;
          }
        }
      });
    }, 1000);
  }

  renderSubheadingBar = (errorFeeds: number, messageCount: number) => {
    const { classes } = this.props;
    return (
      <div className={classes.subheadingBar}>
        <div>
          <Tabs value={this.state.tab} onChange={this.handleTabChange}>
            <Tab label="ALL STREAMS" />
            <Tab
              value={1}
              label={
                <Badge color="secondary" badgeContent={errorFeeds}>
                  ERROR STREAMS
                </Badge>
              }
            />
            <Tab
              value={2}
              label={
                <Badge color="secondary" badgeContent={messageCount}>
                  ERROR LOGS
                </Badge>
              }
            />
          </Tabs>
        </div>
        <div>
          <IconButton className={classes.iconButton}>
            <MyTooltip title="Audio notification">
              <Switch
                checked={this.state.audioNotify}
                onClick={() => this.disableNotification()}
              />
            </MyTooltip>
          </IconButton>
          <IconButton
            className={classes.iconButton}
            onClick={() =>
              this.setState({
                width: this.state.width + 0.5
              })
            }
          >
            <MyTooltip title={'Zoom In'}>
              <ZoomIn />
            </MyTooltip>
          </IconButton>
          <IconButton
            className={classes.iconButton}
            onClick={() =>
              this.setState({
                width:
                  this.state.width > 15
                    ? this.state.width - 0.5
                    : this.state.width
              })
            }
          >
            <MyTooltip title={'Zoom Out'}>
              <ZoomOut />
            </MyTooltip>
          </IconButton>
          <IconButton
            className={classes.iconButton}
            onClick={() => this.clearStorage()}
          >
            <MyTooltip title={'Clear Error'}>
              <Refresh />
            </MyTooltip>
          </IconButton>

          <IconButton
            className={classes.iconButton}
            onClick={() =>
              this.setState({
                isFull: !this.state.isFull
              })
            }
          >
            {!this.state.isFull ? (
              <MyTooltip title={'Switch to full screen'}>
                <FullscreenSharp />
              </MyTooltip>
            ) : (
              <MyTooltip title={'Exit full screen'}>
                <FullscreenExit
                  onClick={() =>
                    this.setState({
                      isFull: !this.state.isFull
                    })
                  }
                />
              </MyTooltip>
            )}
          </IconButton>
        </div>
      </div>
    );
  };
  handleOpenPlayoutFeedSummary = (playoutFeedId: string) => {
    this.setState({
      selectedPlayoutFeed: playoutFeedId,
      openPlayoutSummary: true
    });
  };
  handleClosePlayoutFeedSummary = () => {
    this.setState({
      openPlayoutSummary: false,
      selectedPlayoutFeed: undefined
    });
  };

  getRequestParams = (
    method,
    region,
    payload,
    { accessKeyId, secretAccessKey }
  ) => {
    if (!region) {
      throw new Error("Missing required argument: 'region' is required.");
    }
    if (!method) {
      throw new Error("Missing required argument: 'method' is required.");
    }
    const opts = {
      service: 'logs',
      body: '',
      region,
      path: `/?Action=${method}`,
      hostname: '',
      headers: {
        'X-Amz-Target': `Logs_20140328.${method}`,
        Accept: 'application/json',
        'Content-Type': 'application/x-amz-json-1.1'
      }
    };

    if (payload) {
      opts.body = JSON.stringify(payload);
    }

    if (accessKeyId && secretAccessKey) {
      aws4.sign(opts, { accessKeyId, secretAccessKey });
    } else {
      aws4.sign(opts);
    }

    return {
      uri: `https://${opts.hostname}${opts.path}`,
      headers: opts.headers
    };
  };

  checkIfLogStreamExists = (
    logStream,
    { logGroupName, region, accessKeyId, secretAccessKey, local }
  ) => {
    if (local && local !== 'false') {
      return Promise.resolve({
        message: 'No need to create stream. Local mode is on.'
      });
    }

    const service = 'GetLogEvents';
    const payload = {
      logGroupName,
      logStreamName: logStream,
      limit: 1
    };

    const { uri, headers } = this.getRequestParams(service, region, payload, {
      accessKeyId,
      secretAccessKey
    });

    const request = logAxios.create({
      baseURL: uri,
      headers
    });

    return request
      .post('', payload)
      .then(results => true)
      .catch(err => {
        if (
          err.response.data.message ===
          'The specified log stream does not exist.'
        ) {
          return false;
        } else {
          throw new Error(err.response.data.message);
        }
      });
  };
  sleep = ms => new Promise(r => setTimeout(r, ms));

  logToCloudWatch = async (msg: any, ts = moment().valueOf()) => {
    try {
      const globalVariables = globalThis.UI_CONFIG;
      const hostName = window.location.hostname;
      const screenName = this.props.screens.screenMap[this.props.selectedScreen]
        .name;
      const { name } = this.props.user;
      const updatedMessageLog = {
        msg: { ...msg },
        browserTimestamp: moment().valueOf(),
        triggerTimestamp: ts,
        podName: screenName,
        userName: name
      };
      const config = {
        logGroupName: globalVariables.logGroupName,
        logStreamName: '',
        region: globalVariables.region,
        accessKeyId: globalVariables.accessKeyId,
        secretAccessKey: globalVariables.secretAccessKey,
        local: false // Optional. If set to true, the log will fall back to the standard 'console.log'.
      };
      const logStream = `${hostName} - ${screenName} - ${moment().format(
        'DD-MM-YYYY'
      )}`;
      await this.checkIfLogStreamExists(logStream, config).then(
        async created => {
          if (!created) {
            createLogStream(logStream, config).then(async resultData => {
              config.logStreamName = logStream;
              const logger = new Logger(config);
              await logger.log(updatedMessageLog);
              console.log('waiting...');
              await this.sleep(2000);
            });
          } else {
            config.logStreamName = logStream;
            const logger = new Logger(config);
            await logger.log(updatedMessageLog);
            console.log('waiting...');
            await this.sleep(2000);
          }
        }
      );
    } catch (e) {
      console.log(e);
    }
  };

  // send UI logs to the cloudwatch
  sendMsgToCloudWatch = async (
    msg: any,
    wait = 300,
    ts = moment().valueOf()
  ) => {
    try {
      if (this.state.cloudWatchLock) {
        console.log('Wait for lock to release');
        setTimeout(this.sendMsgToCloudWatch, 2 * (wait + 200), msg, wait, ts);
        return;
      } else {
        console.log('lock is acquired');
        this.setState({ cloudWatchLock: true });
        await this.logToCloudWatch(msg, ts);
        console.log('lock is released');
        this.setState({ cloudWatchLock: false });
      }
    } catch (e) {
      console.log(e);
    }
  };

  componentDidUpdate() {
    if (this.props.playoutIds.length !== 0 && !this.state.isSubscribed) {
      const channels = this.props.playoutIds.map((id: string) =>
        `doordarshan|${id.split('#').join('|')}`.replace(/\./g, '_')
      );
      this.pubnub.subscribe({
        channels,
        withPresence: true,
        autoload: 1,
        restore: true
      });
      this.setState({ isSubscribed: true });
      this.pubnub.addListener({
        message: msg => {
          // handle message
          if (msg) {
            const pubNubMsg = { type: 'PUBNUB', details: { ...msg } };
            this.sendMsgToCloudWatch(pubNubMsg);
            msg.message.received_at = moment().format('YYYY-MM-DD HH:mm:ss');
            this.props.updateFeeds(msg.message ? [msg.message] : []);
            const feed = msg.message;
            const feedId = `${feed.customer}#${feed.feed_code}#${feed.headend}`.replace(
              /\./g,
              '_'
            );
            if (msg.message.status === 'ERROR' && this.state.audioNotify) {
              if (!this.state.alarmFeeds.includes(feedId)) {
                const alarmFeeds = this.state.alarmFeeds;
                alarmFeeds.push(feedId);
                this.setState({ alarmFeeds });
              }
              this.playAlarm(false);
            } else if (msg.message.status === 'OK') {
              const alarmFeeds = this.state.alarmFeeds;
              const index = alarmFeeds.indexOf(feedId);
              if (index > -1) {
                alarmFeeds.splice(index, 1);
              }
              this.state.messages.forEach(message => {
                if (
                  message.feed_id.replace(/\./g, '_') === feedId &&
                  (!message.ended_at || message.ended_at === 'NA')
                ) {
                  message.ended_at = moment().format('YYYY-MM-DD HH:mm:ss');
                }
              });
              this.setState({ alarmFeeds });
              this.playAlarm(false);
            }
          }
        }
      });

      this.pubnub.fetchMessages(
        { channels: this.props.playoutIds, count: 1 },
        (status, hist) => {
          let oldMessages = [];
          if (status.error === false && hist) {
            Object.keys(hist.channels).map((channelName: string) => {
              if (hist.channels[channelName].length !== 0) {
                if (hist.channels[channelName][0].message) {
                  oldMessages = [
                    ...oldMessages,
                    hist.channels[channelName][0].message
                  ];
                }
              }
            });
          }
          this.props.updateFeeds(oldMessages);
        }
      );
    }

    localStorage.setItem('messages', JSON.stringify(this.state.messages));
    this.playAlarm(false);
  }
  filterPlayoutFeeds = playoutFeeds => {
    const { searchText } = this.state;
    return playoutFeeds.filter(
      feedInfo =>
        (feedInfo.customer &&
          feedInfo.customer.toLowerCase().indexOf(searchText) !== -1) ||
        (feedInfo.name &&
          feedInfo.name.toLowerCase().indexOf(searchText) !== -1)
    );
  };

  disableNotification() {
    const audioNotify = this.state.audioNotify;
    const audioNotifyMsg = { type: 'INFO', details: '' };
    this.setState({ audioNotify: !audioNotify });
    audioNotify
      ? (audioNotifyMsg.details = 'User has turned off the audio alarm')
      : (audioNotifyMsg.details = 'User has turned on the audio alarm');
    this.sendMsgToCloudWatch(audioNotifyMsg);
    localStorage.setItem('disableNotification', audioNotify ? 'true' : 'false');
  }

  async playAlarm(stop) {
    const alarmStatusMsg = { type: 'INFO', details: '' };
    const notEndedMessages = this.state.messages.filter(msg => {
      if (!this.props.playoutIds.includes(msg.feed_id)) {
        return;
      }

      if ((!msg.ended_at || msg.ended_at === 'NA') && !msg.snooze) {
        return msg;
      }
    });
    if (
      (stop && !this.state.alarm.paused) ||
      (!this.state.alarm.paused && !this.state.audioNotify) ||
      (!this.state.alarm.paused && notEndedMessages.length === 0)
    ) {
      this.setState({ isAlarming: false });
      this.state.alarm.pause();
      alarmStatusMsg.details = 'Audio alarm is paused';
      this.sendMsgToCloudWatch(alarmStatusMsg);
    } else if (
      notEndedMessages.length > 0 &&
      this.state.alarm.paused &&
      this.state.audioNotify
    ) {
      this.state.alarm.loop = true;
      try {
        await this.state.alarm.play();
        this.setState({ isAlarming: true });
        alarmStatusMsg.details = 'Audio alarm is playing now';
        this.sendMsgToCloudWatch(alarmStatusMsg);
      } catch (err) {
        console.log(err);
        alarmStatusMsg.type = 'Error';
        alarmStatusMsg.details = err.message;
        this.sendMsgToCloudWatch(alarmStatusMsg);
      }
    }
  }

  public clearStorage() {
    this.setState({
      refresh: this.state.refresh + 1
    });
    localStorage.setItem('messages', JSON.stringify([]));
    this.setState({ messages: [] });
  }

  handleOpenSnoozeForm = () => {
    this.setState({
      confirmationDialogProps: {
        type: ConfirmationTypes.SNOOZE,
        open: true,
        onCloseDialog: this.handleCloseSnoozeForm,
        onProceedDialog: this.handleSnooze,
        content: this.renderSnoozeForm(),
        title: 'Snooze Alert'
      }
    });
  };
  handleCloseSnoozeForm = () => {
    this.setState({
      snoozeHrs: 0,
      snoozeMins: 0,
      confirmationDialogProps: initialConfirmationState
    });
  };
  handleSnooze = () => {
    const epoch = Math.floor(
      Math.floor(this.state.snoozeHrs) * 3600 +
        Math.floor(this.state.snoozeMins) * 60
    );

    const selectedFeed = this.state.selectedPlayoutFeed;

    this.state.messages.forEach(msg => {
      if (!this.props.playoutIds.includes(msg.feed_id)) {
        return;
      }
      if (
        msg.feed_id === selectedFeed &&
        (msg.ended_at === 'NA' || !msg.ended_at)
      ) {
        msg.snooze = true;
        msg.snooze_until = moment()
          .add(epoch, 'seconds')
          .format();
      }
    });
    this.playAlarm(true);
    this.handleCloseSnoozeForm();
  };
  handleSnoozeChange = (e, type: string) => {
    if (type === 'hrs') {
      this.setState({ snoozeHrs: parseInt(e.target.value, 10) });
    } else {
      this.setState({ snoozeMins: parseInt(e.target.value, 10) });
    }
  };

  renderSnoozeForm = () => {
    return (
      <Snooze
        hrs={this.state.snoozeHrs}
        mins={this.state.snoozeMins}
        para={`This will disable alarm for the chosen duration. 
        Alarm will resume once snooze duration expires. Do you wish to continue?`}
        onChangeSnoozeTime={this.handleSnoozeChange}
      />
    );
  };

  renderConfirmationContent = () => {
    switch (this.state.confirmationDialogProps.type) {
      case ConfirmationTypes.SNOOZE:
        return this.renderSnoozeForm();
      default:
        return null;
    }
  };

  public render() {
    const {
      playoutCustomerToFeedInfoMap,
      isFetching,
      updateFeeds
    } = this.props;
    let playoutFeeds = Object.values(playoutCustomerToFeedInfoMap).flatMap(
      playoutFeedList => playoutFeedList
    );

    let errorFeeds = [];
    if (this.state.isRefresh) {
      const messageStr = localStorage.getItem('messages');
      const messages = JSON.parse(messageStr);
      if (messages) {
        messages.forEach(msg => {
          this.state.messages.push(msg);
        });
      }
      this.setState({ isRefresh: false });
    }

    playoutFeeds = this.filterPlayoutFeeds(playoutFeeds);

    const feedsWithError = [];
    this.state.messages.forEach(msg => {
      if (
        (!msg.ended_at || msg.ended_at === 'NA') &&
        !feedsWithError.includes(msg.feed_id)
      ) {
        feedsWithError.push(msg.feed_id);
      }
    });

    errorFeeds = playoutFeeds.filter(feed => {
      const feedId = `${feed.customer}#${feed.feed_code}#${feed.headend}`;
      if (
        feedsWithError.includes(feedId) ||
        (feed.status === 'ERROR' || feed.status === 'WARNING')
      ) {
        if (!feed.status) {
          // set a status after browser refresh
          feed.status = 'ERROR';
          const messages = this.state.messages.filter(msg => {
            if (
              (!msg.ended_at || msg.ended_at === 'NA') &&
              msg.feed_id === feedId
            ) {
              return msg;
            }
          });
          feed.not_ended_messages = messages;
        }

        const snoozedMessages = this.state.messages.filter(msg => {
          if (msg.snooze && msg.feed_id === feedId) {
            return msg;
          }
        });

        if (snoozedMessages.length > 0) {
          feed.snoozed = true;
        } else {
          feed.snoozed = false;
        }
        return feed;
      }
    });

    playoutFeeds.forEach(feed => {
      if (feed.messages && feed.messages.length > 0) {
        const newMessages = [];
        feed.messages.forEach(msg => {
          newMessages.push(msg.id);
          const filtered = this.state.messages.filter(
            m => m.id === msg.id && m.headend === msg.headend
          );
          if (filtered.length === 0) {
            this.state.messages.push(cloneDeep(msg));
          }
        });
        if (newMessages.length > 0) {
          const feedId = `${feed.customer}#${feed.feed_code}#${feed.headend}`;
          this.state.messages.forEach(msg => {
            if (
              msg.feed_id === feedId &&
              (!msg.ended_at || msg.ended_at === 'NA') &&
              !newMessages.includes(msg.id)
            ) {
              msg.ended_at = moment().format('YYYY-MM-DD HH:mm:ss');
            }
          });
        }

        localStorage.setItem('messages', JSON.stringify(this.state.messages));
      }
      feed.messages = [];
    });

    const showMessage =
      !isFetching && this.state.tab === 0
        ? playoutFeeds.length === 0
        : this.state.tab === 1 && errorFeeds.length === 0
        ? true
        : this.state.tab === 2 && this.state.messages.length === 0;
    return (
      <MainSection>
        <MainHeading
          mainHeading={'Playout Monitor'}
          searchPlaceholder={'Search by customer/feed code...'}
          onSearch={this.handleSearch}
          showButton={false}
        />
        <Fullscreen
          enabled={this.state.isFull}
          onChange={isFull => this.setState({ isFull })}
        >
          <SubSection>
            <SubHeading>
              {this.renderSubheadingBar(
                errorFeeds.length,
                this.state.messages.filter(msg => {
                  if (this.props.playoutIds.includes(msg.feed_id)) {
                    return msg;
                  }
                }).length
              )}
            </SubHeading>
            <div style={{ minHeight: '75vh', paddingTop: '1rem' }}>
              {showMessage ? (
                <IconDisplay
                  logo={
                    this.state.tab === 0
                      ? sadsmiley
                      : this.state.tab === 1
                      ? smilie
                      : smilie
                  }
                  message={
                    this.state.tab === 0
                      ? 'No streams found. Please configure the screen correctly.'
                      : this.state.tab === 1
                      ? 'All good here!'
                      : 'No error logs recorded!'
                  }
                />
              ) : this.state.tab !== 2 ? (
                <FarFieldMonitoring
                  isFetching={this.props.isFetching}
                  playoutFeeds={
                    this.state.tab === 0 ? playoutFeeds : errorFeeds
                  }
                  webRTCConfigHash={this.props.webRTCConfigHash}
                  width={this.state.width}
                  key={this.state.refresh}
                  tab={this.state.tab}
                  onOpenPlayoutFeedSummary={this.handleOpenPlayoutFeedSummary}
                  screen={
                    this.props.selectedScreen
                      ? this.props.screens.screenMap[this.props.selectedScreen]
                      : undefined
                  }
                />
              ) : (
                <MessageLogs
                  logs={this.state.messages.filter(msg => {
                    if (this.props.playoutIds.includes(msg.feed_id)) {
                      return msg;
                    }
                  })}
                />
              )}
            </div>
          </SubSection>
        </Fullscreen>
        <ConfirmationDialog
          {...this.state.confirmationDialogProps}
          proceedDisabled={false}
        >
          {this.renderConfirmationContent()}
        </ConfirmationDialog>
        <MyDialog
          open={this.state.openPlayoutSummary}
          onClose={this.handleClosePlayoutFeedSummary}
          title={'Stream Summary'}
          maxWidth={false}
        >
          <PlayoutStreamSummary
            playoutFeed={this.props.playoutMap[this.state.selectedPlayoutFeed]}
            feedMap={this.props.feeds.feedMap}
            onOpenSnoozeForm={this.handleOpenSnoozeForm}
          />
        </MyDialog>
      </MainSection>
    );
  }
}
interface IPlayoutOwnProps extends WithStyles<typeof styles> {}
type IPlayoutProps = IPlayoutOwnProps &
  IPlayoutStateProps &
  IPlayoutDispatchProps;
interface IPlayoutStateProps {
  isFetching: boolean;
  selectedScreen: string;
  screens: IScreenState;
  playoutCustomerToFeedInfoMap: { [key: string]: IPlayoutScreen };
  feeds: IFeedState;
  playoutIds: string[];
  playoutMap: { [key: string]: IPlayoutScreen };
  user: IUser;
  webRTCConfigHash: { [key: string]: IWebRTCConfig };
}
interface IPlayoutDispatchProps {
  fetchPlayoutUrls: (feedCodes: string[], customers: string[]) => any;
  updateFeeds: (feeds: any) => any;
}
const mapStateToProps = (state: IState): IPlayoutStateProps => {
  return {
    isFetching: state.playouts.isFetching,
    selectedScreen: state.screens.selectedScreen,
    screens: state.screens,
    playoutCustomerToFeedInfoMap: state.playouts.playoutMap,
    webRTCConfigHash: state.playouts.webRTCConfigHash,
    playoutIds: state.playouts.playoutIds,
    feeds: state.feeds,
    playoutMap: state.playouts.playoutMap,
    user: state.user.userInfo
  };
};
const mapDispatchToProps: IPlayoutDispatchProps = {
  fetchPlayoutUrls,
  updateFeeds: updatePlayoutFeeds
};
interface IPlayoutOwnState {
  isFull: boolean;
  width: number;
  searchText: string;
  tab: number;
  refresh: number;
  isSubscribed: boolean;
  selectedPlayoutFeed: string;
  openPlayoutSummary: boolean;
  audioNotify: boolean;
  alarmFeeds: string[];
  isAlarming: boolean;
  cloudWatchLock: boolean;
  alarm: HTMLAudioElement;
  isRefresh: boolean;
  messages: any[];
  confirmationDialogProps: IConfirmationDialogState;
  snoozeHrs: number; // hrs
  snoozeMins: number;
}

interface IMessage {
  feed: string;
}
export default withStyles(styles)(
  connect<IPlayoutStateProps, IPlayoutDispatchProps, IPlayoutOwnProps>(
    mapStateToProps,
    mapDispatchToProps
  )(withErrorHandler(PlayoutPod, axios))
);
